import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.valueAttribute = this.data.get('valueAttribute')
    const itemsToLoadDataOnQuery = '*[' + this.valueAttribute + ']'
    const itemsToLoadDataOn = this.element.querySelectorAll(itemsToLoadDataOnQuery)
    itemsToLoadDataOn.forEach(item => this.loadDataOn(item))
  }

  loadDataOn(item) {
    const data = item.getAttribute(this.valueAttribute)
    item.innerHTML = data
  }
}
